import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
// import Dropdown from 'bp-vuejs-dropdown'
import Welcome from './components/Welcome.vue'
import ListeQuestions from './components/ListeQuestions.vue'
import QuestionType1 from './components/QuestionType1.vue'
import QuestionType2 from './components/QuestionType2.vue'
import QuestionType3 from './components/QuestionType3.vue'
import Reponse from './components/Reponse.vue'
import DejaJoue from './components/DejaJoue.vue'
import Reglement from './components/Reglement.vue'
import MentionsLegales from './components/MentionsLegales.vue'
import Credits from './components/Credits.vue'
import QuestionType from './components/QuestionType.vue'
import Auth from './components/Auth.vue'
import './registerServiceWorker'

Vue.BASE_URL = Vue.prototype.BASE_URL = "https://1j1s.fora.fr/Web/";



// Vue.use(Dropdown)
Vue.use(VueRouter)
const routes = [
  {
    path: '/#/Auth/*',
    component: Auth
  },
  {
    path: '/Auth/*',
    component: Auth
  },
  { path: '/', component: Welcome },
  { path: '/ListeQuestions', component: ListeQuestions },
  { path: '/QuestionType1/:id', component: QuestionType1 },
  { path: '/QuestionType2/:id', component: QuestionType2 },
  { path: '/QuestionType3/:id', component: QuestionType3 },
  { path: '/Reponse/:id', component: Reponse },
  { path: '/DejaJoue/:id', component: DejaJoue },
  { path: '/Reglement/:id', component: Reglement },
  { path: '/MentionsLegales', component: MentionsLegales },
  { path: '/Credits', component: Credits },
  { path: '/QuestionType', component: QuestionType },
  { path: '/Auth/:token', component: Auth },
  { path: '/DirectAccess/:username?', component: Welcome }

]
const router = new VueRouter({
  mode: "history",
  routes,
  linkExactActiveClass: 'active',
  base: "/",
  scrollBehavior() {
    window.scrollTo(0, 0);
    document.getElementById('app').scrollIntoView();

  }

})

router.beforeResolve((to, from, next) => {
  var spinner = document.getElementById('spinner');
  if (spinner && to.name) { document.getElementById('spinner').style.display = "block"; }
  next();
});

router.afterEach((to, from) => {
  var spinner = document.getElementById('spinner');
  if (spinner)
    document.getElementById('spinner').style.display = "none";
});


new Vue({
  render: h => h(App),
  router,
  methods: {


  },
  mounted: function () {


  },
  data: {
    IsLog: true
  }
}).$mount('#app')








